module.exports = __webpack_public_path__ + "img/featured5.54fd8d67.png";